<template>
    <div class="card card-pdv card-work-schedule-statement-chart">
        <PageHeader :title="i18nPerformance" />
        <div class="card-body">
            <column-chart
                :categories-series-prop="categories"
                :series-prop="series"
                :hide-legend="true"
                :busy="loading"
                :colors-prop="['#f39c12']"
                :yaxis-config="yaxisConfig"
                data-labels-suffix="%"
                data-labels-position="center"
            />
        </div>
    </div>
</template>

<script>
    import WorkScheduleStatement from '@/src/services/dashboards/widgets/WorkScheduleStatementService'
    import { computeYAxisScaleFromSeries } from '@/src/utils/chart-scale'
    import PageHeader from '@/src/components/PageHeader.vue'
    import ColumnChart from '@/src/components/charts/ColumnChart.vue'
    import swalFeedback from '@src/mixins/swalFeedback.vue'
    import validationMixin from '@src/mixins/validation.vue'
    const i18nKey = 'DASHBOARDS'

    export default {
        components: {
            PageHeader,
            ColumnChart,
        },
        mixins: [
            validationMixin,
            swalFeedback,
        ],
        props: {
            busy: {
                type: Boolean,
                required: false,
            },
        },
        data() {
            return {
                i18nKey,
                loading: false,
                series: [],
                categories: [],
                yaxisConfig: {
                    min: 0,
                    max: 100,
                    tickAmount: 10,
                    forceNiceScale: true,
                    labels: {
                        formatter: (value) => value + '%',
                    },
                },
            }
        },
        validations: {},
        computed: {
            i18nPerformance() {
                return this.getI18n(i18nKey, 'TITLES.performance_percentage')
            },
        },
        methods: {
            refresh(parameters) {
                this.loading = true
                this.series = []
                this.categories = []

                WorkScheduleStatement.perChain(parameters)
                    .then((response) => {
                        const data = response.data.data || {}
                        this.categories = data.categories || []
                        this.series = Array.isArray(data.series) ? data.series : []

                        const scale = computeYAxisScaleFromSeries(this.series, { isPercentage: true })
                        this.yaxisConfig = {
                            ...scale,
                            labels: {
                                formatter: (value) => value + '%',
                            },
                        }

                        this.loading = false
                    })
                    .catch((err) => {
                        this.loading = false
                        return err
                    })
            },
        },
    }
</script>
